import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useTranslation } from "../../../hooks/useTranslation";

interface IProps {
  open: boolean;
  addressText: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Confirms saving an address as TEXT ONLY (no coordinates, no place_id) — warns the user
 * this address will not appear on the map and cannot be used for route optimization.
 * Purely presentational: no formik coupling, the caller applies the actual field changes
 * on confirm.
 */
export const TextOnlyAddressConfirmDialog: React.FC<IProps> = ({ open, addressText, onConfirm, onCancel }) => {
  const { p } = useTranslation("contact_info");

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm" sx={{ zIndex: 10002 }}>
      <DialogTitle>{p("text_only_confirm_title")}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 1 }}>{p("text_only_confirm_body")}</DialogContentText>
        <DialogContentText sx={{ fontWeight: 600 }}>{addressText}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{p("text_only_cancel_button")}</Button>
        <Button onClick={onConfirm} variant="contained" color="warning">
          {p("text_only_confirm_button")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
